import type { TableSortDirections } from './constants'
import type { BaseTableRow, BaseHeader } from './types'

import { tableSortDirections } from './constants'

export function defaultTableSort<
  TR extends BaseTableRow,
  HD extends BaseHeader
>(rows: TR[], sortBy: HD, sortDirection: TableSortDirections): TR[] {
  const rowsToSort = [...rows]

  return rowsToSort.sort((a, b) => {
    if (!sortBy) {
      return 0
    }

    const sortKey = typeof sortBy === 'string' ? sortBy : sortBy.id

    const aValue = a[sortKey as keyof TR]
    const bValue = b[sortKey as keyof TR]

    // Handle null/undefined values - sort them to the end
    if (aValue === null || aValue === undefined) {
      return 1
    }
    if (bValue === null || bValue === undefined) {
      return -1
    }

    if (aValue < bValue) {
      return -1 * (sortDirection === tableSortDirections.DESC ? -1 : 1)
    }

    if (aValue > bValue) {
      return 1 * (sortDirection === tableSortDirections.DESC ? -1 : 1)
    }

    return 0
  })
}
